import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import startupService from '../../services/startupService';

export default function StartupDashboard() {
    const { userProfile } = useAuth();
    const [startup, setStartup] = useState(null);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            if (!userProfile?.startupId) {
                setLoading(false);
                return;
            }
            try {
                setLoading(true);
                const s = await startupService.getStartupById(userProfile.startupId);
                const team = await startupService.getTeamMembers(userProfile.startupId); // optional
                setStartup(s);
                setMembers(team || []);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userProfile]);

    if (loading) return <div>Loading...</div>;
    if (!startup) return <div>Please create your startup profile first: go to Startup Profile.</div>;

    return (
        <div style={{ padding: 20 }}>
            <h2>{startup.name}</h2>
            <p>{startup.description}</p>
            <h3>Team</h3>
            {members.length === 0 ? <p>No team members yet.</p> :
                <ul>{members.map(m => <li key={m.id}>{m.name} — {m.role}</li>)}</ul>}
        </div>
    );
}
